export const GET_ADVOCATE_LIST = "GET_ADVOCATE_LIST";
export const ADVOCATE_PROCESSING = "ADVOCATE_PROCESSING";
export const STOP_ADVOCATE_PROCESSING = "STOP_ADVOCATE_PROCESSING";
